import _typeof from "/app/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
export default {
  name: "PortableText",
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  computed: {
    processedBlocks: function processedBlocks() {
      return this.groupBlocks(this.value);
    }
  },
  methods: {
    groupBlocks: function groupBlocks(blocks) {
      var result = [];
      var currentListGroup = null;
      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i];
        if (this.isListItem(block)) {
          var listType = block.listItem || "bullet";
          var level = block.level || 1;

          // If we're starting a new list or the list type/level changed
          if (!currentListGroup || currentListGroup.listType !== listType || currentListGroup.level !== level) {
            // Save previous list group if it exists
            if (currentListGroup) {
              result.push(currentListGroup);
            }

            // Start new list group
            currentListGroup = {
              type: "list",
              listType: listType,
              level: level,
              items: [block]
            };
          } else {
            // Add to current list group
            currentListGroup.items.push(block);
          }
        } else {
          // Non-list item - save any current list group and add the block
          if (currentListGroup) {
            result.push(currentListGroup);
            currentListGroup = null;
          }
          result.push({
            type: "block",
            block: block
          });
        }
      }

      // Don't forget the last list group if it exists
      if (currentListGroup) {
        result.push(currentListGroup);
      }
      return result;
    },
    isListItem: function isListItem(block) {
      return block._type === "block" && (block.style === "bullet" || block.style === "number" || block.listItem === "bullet" || block.listItem === "number" || block.listItem);
    },
    getCustomComponent: function getCustomComponent(type) {
      // Return a default div for custom types we don't handle
      return "div";
    },
    getBlockComponent: function getBlockComponent(style) {
      var styleMap = {
        normal: "p",
        h1: "h1",
        h2: "h2",
        h3: "h3",
        h4: "h4",
        h5: "h5",
        h6: "h6",
        blockquote: "blockquote"
      };
      return styleMap[style] || "p";
    },
    getMarkComponent: function getMarkComponent(mark, block) {
      // Check if this is a link mark by looking in markDefs
      var markDef = this.getMarkDefinition(mark, block);
      if (markDef && markDef._type === "link") {
        return {
          props: ["value", "text"],
          render: function render(h) {
            var _this$value;
            var href = ((_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.href) || "";
            var target = href.includes("http") || href.includes("www") ? "_blank" : undefined;
            return h("a", {
              attrs: {
                href: href,
                target: target,
                rel: target === "_blank" ? "noreferrer noopener" : undefined
              },
              class: "link"
            }, this.text);
          }
        };
      }

      // Handle other marks like strong, em, etc.
      var markMap = {
        strong: "strong",
        em: "em",
        code: "code",
        underline: "u",
        link: "a"
      };
      return markMap[mark] || "span";
    },
    getMarkValue: function getMarkValue(mark, block) {
      // Find the mark definition in the current block's markDefs
      var markDef = this.getMarkDefinition(mark, block);
      return markDef || null;
    },
    getMarkDefinition: function getMarkDefinition(mark, block) {
      // If mark is a string, look for it in the block's markDefs
      if (typeof mark === "string" && block && block.markDefs) {
        return block.markDefs.find(function (def) {
          return def._key === mark;
        });
      }
      // If mark is already an object, return it
      if (_typeof(mark) === "object") {
        return mark;
      }
      return null;
    }
  }
};